import { X } from "lucide-react";

export default function ImportHistoryModal({
  open,
  count,
  onImport,
  onSkip,
  busy,
}) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[80] flex items-center justify-center px-4"
      data-testid="import-history-modal"
      role="dialog"
    >
      <div
        className="absolute inset-0 bg-[var(--text)]/70"
        onClick={busy ? undefined : onSkip}
        aria-hidden="true"
      />
      <div className="relative w-full max-w-md bg-[var(--bg-elevated)] border border-[var(--border)] shadow-2xl p-6">
        <button
          onClick={onSkip}
          disabled={busy}
          className="absolute top-3 right-3 text-[var(--text-dim)] hover:text-[var(--text)] transition-colors disabled:opacity-40"
          data-testid="import-history-close"
          aria-label="Close"
        >
          <X size={16} />
        </button>
        <div className="font-mono-ui text-[10px] tracking-[0.32em] uppercase text-[var(--accent)] mb-3">
          Carry over
        </div>
        <h3 className="font-prose text-2xl text-[var(--text)] leading-tight mb-3">
          Bring your previous {count === 1 ? "chat" : `${count} chats`} into this account?
        </h3>
        <p className="font-ui text-sm text-[var(--text-muted)] leading-relaxed mb-6">
          We found {count === 1 ? "a conversation" : `${count} conversations`} saved in
          this browser from before you signed in. Import them once and they&apos;ll sync
          across your devices from now on. Skip to leave them browser-only.
        </p>
        <div className="flex flex-col sm:flex-row gap-3">
          <button
            onClick={onImport}
            disabled={busy}
            data-testid="import-history-confirm"
            className="flex-1 py-2.5 font-mono-ui text-[10px] tracking-[0.28em] uppercase border border-[var(--accent)] text-[var(--accent)] hover:bg-[var(--accent)] hover:text-[var(--bg)] disabled:opacity-40 transition-colors"
          >
            {busy ? "Importing…" : "Import them"}
          </button>
          <button
            onClick={onSkip}
            disabled={busy}
            data-testid="import-history-skip"
            className="flex-1 py-2.5 font-mono-ui text-[10px] tracking-[0.28em] uppercase border border-[var(--border)] text-[var(--text-muted)] hover:text-[var(--text)] hover:border-[var(--text)] disabled:opacity-40 transition-colors"
          >
            Skip
          </button>
        </div>
      </div>
    </div>
  );
}
